import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
// import { render } from "react-dom";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import "./hw2-grid.css";
import Canvas1 from "../Canvas1";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS

import { ModuleRegistry } from "@ag-grid-community/core";
// import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
// import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";

// import { useState } from "react";
import { AnimateCC, GetAnimationObjectParameter } from "react-adobe-animate";
import Hw5List from "../Hw5List";

// Register the required feature modules with the Grid
// ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);
  const initialAnimaciones = [
    // const animaciones = [
      // { id: 1, name: "lishtml5", animurl: "/lishtml5.js", loaded: false, composition: "a" },
      // { id: 2, name: "ils1", animurl: "/image/ils1.js", loaded: false, composition: "b" },
      // { id: 3, name: "verticalspeed1", animurl: "/image/verticalspeed1.js", loaded: false , composition: "c" },
      // { id: 1, name: "lishtml5", animurl: "lishtml5.js", composition: "animation2" },
      // { id: 2, name: "ils1", animurl: "ils1.js", composition: "F42BBEB1D5E27943A0F71B0F22069701" },
      // { id: 3, name: "verticalspeed1", animurl: "image/verticalspeed1.js", composition: "E716904B9F00294587CFABDE82EDB438" },
      // { id: 4, name: "image", animurl: "/image/image.js", composition: "" },
      { id: 1, name: "lishtml5", animurl: "lishtml5.js", composition: "" },
      { id: 2, name: "ils1", animurl: "ils1.js", composition: "" },
      { id: 3, name: "verticalspeed1", animurl: "image/verticalspeed1.js", composition: "" },
      { id: 4, name: "image", animurl: "/image/image.js", composition: "" },
    ];
    

const Hw2 = () => {
  const [animaciones, setAnimaciones] = useState(initialAnimaciones);

  const gridRef = useRef(); // Optional - for accessing Grid's API
  const gridRef2 = useRef(); // Optional - for accessing Grid's API
  //const gridStyle = useMemo(() => ({ width: "100%", height: 500 }), []);
  //const gridStyle2 = useMemo(() => ({ width: "100%", height: 500 }), []);
  const gridStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle2 = useMemo(() => ({ width: "100%", height: "90%" }), []);
  var [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  var [rowData2, setRowData2] = useState(); // Set rowData to Array of Objects, one Object per Row

  rowData = [
    { id: "aa", swid2: 0, hw_t1: "Altimetro", 0: "Celica", val_t1: 35000 },
    { id: "bb", swid2: 0, hw_t1: "Rumbo", 1: "Mondeo", val_t1: 32000 },
  ];

  rowData2 = [
    { id: "xx", hw_t2: "Altimetro", cnt_t2: 2, val_t2: 35000 },
    { id: "yy", hw_t2: "Rumbo", cnt_t2: 3, val_t2: 32000 },
  ];

  const gridOptions = {
    // PROPERTIES
    // Objects like myRowData and myColDefs would be created in your application
    rowData: rowData,

    // EVENTS
    // Add event handlers
    //    onRowClicked: (event) => console.log("A row was clicked"),
    onColumnResized: (event) => console.log("A column was resized"),
    onGridReady: (event) => console.log("The grid is now ready"),
    // onCellClicked: (event) =>cellClickedListener, // Optional - registering for Grid Event

    // CALLBACKS
    // isScrollLag: () => false,
  };

  const gridOptions2 = {
    // PROPERTIES
    // Objects like myRowData and myColDefs would be created in your application
    rowData: rowData2,

    // EVENTS
    // Add event handlers
    //    onRowClicked2: (event) => console.log("A row was clicked"),
    onColumnResized: (event) => console.log("A column was resized"),
    onGridReady: (event) => console.log("The grid is now ready"),
    // onCellClicked: (event) =>cellClickedListener, // Optional - registering for Grid Event

    // CALLBACKS
    // isScrollLag: () => false,
  };

  const updateSort = useCallback((e) => {
    gridOptions.api.refreshClientSideRowModel("sort");
  }, [gridOptions.api]);

  const updateSort2 = useCallback((e) => {
    gridOptions2.api.refreshClientSideRowModel("sort");
  }, [gridOptions2.api]);

  const updateFilter = useCallback((e) => {
    gridOptions.api.refreshClientSideRowModel("filter");
  }, [gridOptions.api]);

  const updateFilter2 = useCallback((e) => {
    gridOptions2.api.refreshClientSideRowModel("filter");
  }, [gridOptions2.api]);

  // const setFilter_ble = useCallback(() => {
  //   var hardcodedFilter = {
  //     country: {
  //       type: 'set',
  //       values: ['Ireland', 'United States'],
  //     },
  //     age: { type: 'lessThan', filter: '30' },
  //     athlete: { type: 'startsWith', filter: 'Mich' },
  //     date: { type: 'lessThan', dateFrom: '2010-01-01' },
  //   };
  //   gridRef.current.api.setFilterModel(hardcodedFilter);
  // }, []);

  const setFilter_ble = useCallback(() => {
    var hardcodedFilter = {
      // id: { type: 'set', values: ['Ireland', 'United States'], },
      // age: { type: 'lessThan', filter: '30' },
      id: { type: "startsWith", filter: "ble" },
      // date: { type: 'lessThan', dateFrom: '2010-01-01' },
    };
    gridRef2.current.api.setFilterModel(hardcodedFilter);
  }, []);

  const clearFilters2 = useCallback(() => {
    gridRef2.current.api.setFilterModel(null);
  }, []);

  // // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "id",
      filter: true,
      editable: true,
      width: 80,
      minWidth: 50,
      maxWidth: 200,
      resizable: true,
      // checkbox: true,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },

    {
      field: "topic_t1",
      filter: true,
      editable: true,
      width: 60,
      minWidth: 50,
      maxWidth: 200,
      resizable: true,
    },

    {
      field: "swid2",
      filter: true,
      sort: "desc",
      editable: true,
      width: 60,
      minWidth: 50,
      maxWidth: 200,
      resizable: true,
    },

    {
      field: "message_t1",
      filter: true,
      editable: true,
      width: 400,
      minWidth: 200,
      maxWidth: 900,
      resizable: true,
      wrapText: true,
    },
    {
      field: "hw_t1",
      filter: true,
      editable: true,
      width: 50,
      minWidth: 30,
      maxWidth: 100,
      resizable: true,
    },
    {
      field: "cnt_t1",
      filter: true,
      editable: true,
      width: 30,
      minWidth: 20,
      maxWidth: 100,
      resizable: true,
    },
    { field: "val_t1", editable: true, width: 30 },
  ]);

  // // Each Column Definition results in one Column.
  const [columnDefs2, setColumnDefs2] = useState([
    {
      field: "id",
      filter: true,
      editable: true,
      width: 80,
      minWidth: 50,
      maxWidth: 200,
      resizable: true,
      // checkbox: true,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      field: "topic_t2",
      filter: true,
      editable: true,
      width: 60,
      minWidth: 50,
      maxWidth: 200,
      resizable: true,
    },

    {
      field: "message_t2",
      filter: true,
      editable: true,
      width: 400,
      minWidth: 200,
      maxWidth: 900,
      resizable: true,
      wrapText: true,
    },
    {
      field: "hw_t2",
      filter: true,
      editable: true,
      width: 50,
      minWidth: 30,
      maxWidth: 100,
      resizable: true,
    },
    {
      field: "cnt_t2",
      filter: true,
      editable: true,
      width: 30,
      minWidth: 20,
      maxWidth: 100,
      resizable: true,
    },
    { field: "val_t2", editable: true, width: 30 },
  ]);


  const getRowId = useMemo(() => {
    return (params) => params.data.id;
  }, []);

  const getRowId2 = useMemo(() => {
    return (params) => params.data.id;
  }, []);

  const getRowHeight = (params) => {
    // if (params.node.group && groupHeight != null) {
    //   return groupHeight;
    // } else if (
    //   params.data &&
    //   params.data.country === 'Russia' &&
    //   russiaHeight != null
    // ) {
    //   return russiaHeight;
    // } else if (
    //   params.data &&
    //   params.data.sport === 'Swimming' &&
    //   swimmingHeight != null
    // ) {
    //   return swimmingHeight;
    // }
    return 40;
  };

  const getRowHeight2 = (params) => {
    // if (params.node.group && groupHeight != null) {
    //   return groupHeight;
    // } else if (
    //   params.data &&
    //   params.data.country === 'Russia' &&
    //   russiaHeight != null
    // ) {
    //   return russiaHeight;
    // } else if (
    //   params.data &&
    //   params.data.sport === 'Swimming' &&
    //   swimmingHeight != null
    // ) {
    //   return swimmingHeight;
    // }
    return 80;
  };

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      width: 80,
      //   editable: true,
      sortable: true,
      suppressMovable: true,
      //   filter: true,
    };
  }, []);

  const defaultColDef2 = useMemo(() => {
    return {
      flex: 1,
      width: 80,
      //   editable: true,
      sortable: true,
      suppressMovable: true,
      //   filter: true,
    };
  }, []);

  const rowClassRules = {
    "red-row": "data.swid2 == 1",
    // "green-row": 'data.swid2 == 1',
    // "blue-row": 'data.swid2 == "Blue"',
  };

  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const cellClickedListener2 = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const rowClickedListener = useCallback((event) => {
    console.log("rowClickedListener", event);
    console.log("event.data.id", event.data.id);
    //params.data.country
    var hardcodedFilter = {
      // id: { type: 'set', values: ['Ireland', 'United States'], },
      // age: { type: 'lessThan', filter: '30' },
      //id: { type: 'startsWith', filter: 'ble' },
      id: { type: "startsWith", filter: event.data.id },
      // date: { type: 'lessThan', dateFrom: '2010-01-01' },
    };
    gridRef2.current.api.setFilterModel(hardcodedFilter);
  }, []);

  const rowClickedListener2 = useCallback((event) => {
    console.log("rowClickedListener2", event);
  }, []);


  // // Example load data from sever
  // useEffect(() => {
  //   fetch('https://www.ag-grid.com/example-assets/row-data.json')
  //   .then(result => result.json())
  //   // .then(rowData => setRowData(rowData))
  //   .then(rowData => setRowData(initialUsers))
  // }, []);

  // -------------------
  // useEffect(() => {
  //   //console.log("App render");
  // })

  useEffect(() => {
    document.addEventListener("mqtt1Rx1", onMqttMsg1);

    function onMqttMsg1(event) {
      onUpdateTabla1(event);
      onUpdateTabla2(event);
    }

    function onUpdateTabla1(event) {
      //function onMqttMsg1(event) {
      const userObj = JSON.parse(event.detail.message);
      const rowNode = gridOptions.api.getRowNode(userObj.id);
      if (gridOptions.api.getRowNode(userObj.id) === undefined) {
        //"undefined" no existe entonces añadimos
        console.log(userObj.id + " :no existe entonces añadimos....");
        // const res = gridRef.current.api.applyTransaction({
        gridRef.current.api.applyTransaction({
            add: [
            {
              id: userObj.id,
              topic_t1: event.detail.topic,
              swid2: userObj.swid2,
              message_t1: event.detail.message,
              hw_t1: "AirSpeed",
              cnt_t1: 1,
              val_t1: "63000",
            },
          ],
        });
        // console.log("res:" + res);
      } else {
        // existe entonces modificamos
        console.log("existe entonces modificamos....");
        console.log("tabla1 event.data.id", event.data);
        // const res2 = gridRef.current.api.applyTransaction({
        gridRef.current.api.applyTransaction({
            update: [
            {
              id: userObj.id,
              topic_t1: event.detail.topic,
              swid2: userObj.swid2,
              message_t1: event.detail.message,
              hw_t1: "AirSpeed",
              cnt_t1: rowNode.data.cnt_t1 + 1,
              val_t1: Math.floor(Math.random() * 100000),
            },
          ],
        });
        // console.log("res2:" + res2);
      }
    }

    function onUpdateTabla2(event) {
      //function onMqttMsg1(event) {
      // const userObj = JSON.parse(event.detail.message);
      const userObj = event.detail.topic;
      const rowNode = gridOptions2.api.getRowNode(event.detail.topic);

      if (gridOptions2.api.getRowNode(event.detail.topic) === undefined) {
        // if (gridOptions2.api.getRowNode(rowNode) === undefined) {
        //"undefined" no existe entonces añadimos
        console.log(userObj.id + " :no existe entonces añadimos....");
        gridRef2.current.api.applyTransaction({
          add: [
            {
              // id: userObj.id,
              id: event.detail.topic,
              topic_t2: event.detail.topic,
              message_t2: event.detail.message,
              hw_t2: "VerticalSpeed",
              cnt_t2: 1,
              val_t2: "4000",
            },
          ],
        });
        // console.log("res:" + res);
      } else {
        // existe entonces modificamos
        console.log("Tabla2 existe entonces modificamos....");
        // console.log("Tabla2 rowNode.data.id"+ rowNode.data.id  );
        gridRef2.current.api.applyTransaction({
          update: [
            {
              id: event.detail.topic,
              topic_t2: event.detail.topic,
              message_t2: event.detail.message,
              hw_t2: "VerticalSpeed",
              // cnt_t2: 1 + Math.floor(Math.random() * 1000),
              cnt_t2: rowNode.data.cnt_t2 + 1,
              val_t2: Math.floor(Math.random() * 100000),
            },
          ],
        });
        // console.log("res2:" + res2);
      }
    }

    return () => {
      document.removeEventListener("mqtt1Rx1", onMqttMsg1);
    };
    //}, [users]);
  }, [gridOptions.api, gridOptions2.api]);

  // -------------------

  // Example using Grid's API
  const deselectAllListener1 = useCallback((e) => {
    console.log("deselectAllListener1");
    gridRef.current.api.deselectAll();
  }, []);

  const deselectAllListener2 = useCallback((e) => {
    console.log("deselectAllListener2");
    gridRef2.current.api.deselectAll();
  }, []);

  const addButtonListener2 = useCallback((e) => {
    console.log("addButtonListener2");
    gridRef.current.api.updateRowData({
      add: [
        {
          hw: "AirSpeed",
          cnt_t1: Math.floor(Math.random() * 1000),
          val_t1: 63000,
        },
      ],
    });
  }, []);

  const setVal_t1OnAltimetro = useCallback((e) => {
    console.log("setVal_t1OnAltimetro");
    var rowNode = gridOptions.api.getRowNode("aa");
    console.log("setVal_t1OnAltimetro getRowNode('aa')" + rowNode);
    var newval_t1 = Math.floor(Math.random() * 100000);
    rowNode.setDataValue("val_t1", newval_t1);
  }, [gridOptions.api]);

  const setDataOnRumbo = useCallback((e) => {
    console.log("setDataOnRumbo");
    var rowNode = gridOptions.api.getRowNode("bb");
    console.log("setDataOnRumbo getRowNode('aa')" + rowNode);
    var newval_t1 = Math.floor(Math.random() * 100000);
    var newModel = 1 + Math.floor(Math.random() * 1000);
    var newData = {
      id: "bb",
      hw_t1: "Rumbo",
      cnt_t1: newModel,
      val_t1: newval_t1,
    };
    rowNode.setData(newData);
  }, [gridOptions.api]);

  // //https://www.ag-grid.com/archive/26.0.0/react-data-grid/grid-interface/
  // // in onGridReady, store the api for later use
  // onGridReady = (params) => {
  //   // using hooks - setGridApi/setColumnApi are returned by useState
  //   setGridApi(params.api);
  //   setColumnApi(params.columnApi);

  //   // or setState if using components
  //   this.setState({
  //       gridApi: params.api,
  //       columnApi: params.columnApi
  //   });
  // }

  // // use the api some point later!
  // somePointLater() {
  //   // hooks
  //   gridApi.selectAll();
  //   columnApi.setColumnVisible('country', visible);

  //   // components
  //   this.state.gridApi.selectAll();
  //   this.state.columnApi.setColumnVisible('country', visible);
  // }

  return (
    <div>
      {/* Example using Grid's API */}
      <button onClick={deselectAllListener1}>Unselect Rows</button>
      <button onClick={addButtonListener2}>Añadir Rows</button>
      <button onClick={setVal_t1OnAltimetro}>Set val_t1 on Altimetro</button>
      <button onClick={setDataOnRumbo}>Set Data On Rumbo</button>
      {/* <button onClick={updateSort} style="margin-left: 15px;">Sort</button> */}
      <button onClick={updateSort}>Sort</button>
      <button onClick={updateFilter}>Filter</button>
      <ul className="hw2Grid-container">
        <li className="hw2Grid-item">
          <div style={gridStyle} className="ag-theme-alpine">
            <AgGridReact
              gridOptions={gridOptions}
              ref={gridRef} // Ref for accessing Grid's API
              // rowData={rowData} // Row Data for Rows
              columnDefs={columnDefs} // Column Defs for Columns
              getRowId={getRowId}
              getRowHeight={getRowHeight}
              defaultColDef={defaultColDef} // Default Column Properties
              rowClassRules={rowClassRules}
              rowSelection="multiple" // Options - allows click selection of rows
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              onRowClicked={rowClickedListener}
              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              // inside onGridReady, you receive the grid APIs if you want them ----conectar mqtt----
              // onGridReady={this.onGridReady}
            />
          </div>
        </li>
        <li className="hw2Grid-item">
          <div style={gridStyle2} className="ag-theme-alpine">
            <button onClick={deselectAllListener2}>Unselect Rows</button>
            <button onClick={updateSort2}>Sort2</button>
            <button onClick={updateFilter2}>Filter2</button>
            <button onClick={clearFilters2}>Reset Filters</button>
            <button onClick={setFilter_ble}>Set Filter ble...</button>
            <AgGridReact
              gridOptions={gridOptions2}
              ref={gridRef2} // Ref for accessing Grid's API
              // rowData={rowData} // Row Data for Rows
              columnDefs={columnDefs2} // Column Defs for Columns
              getRowId={getRowId2}
              getRowHeight={getRowHeight2}
              defaultColDef={defaultColDef2} // Default Column Properties
              rowSelection="multiple" // Options - allows click selection of rows
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              onRowClicked={rowClickedListener2}
              onCellClicked={cellClickedListener2} // Optional - registering for Grid Event
              // inside onGridReady, you receive the grid APIs if you want them ----conectar mqtt----
              // onGridReady={this.onGridReady}
            />
          </div>
        </li>
        <li className="hw2Grid-item">
          <div>sensores val</div>
          <Hw5List animaciones={animaciones} />
        </li>
        <li className="hw2Grid-item">
          <div style={{ background: "#d5e6db" }}>
            Simulacion
            {/* <Canvas1 id="Canvas1" width="200" height= "100" style={pr1}></Canvas1> */}
            {/* <Canvas1 id="Canvas1" width="200" height= "100" ></Canvas1> */}
            <Canvas1></Canvas1>
            {/* <Canvas1 id="Canvas1" height= "100%" style={pr1}></Canvas1> */}
          </div>
        </li>
        <li className="hw2Grid-item">
          <div style={{ background: "#d5e6db" }}>
            Simulacion2
            <Canvas1></Canvas1>
          </div>
        </li>
      </ul>
    </div>
  );
};

//  render(<Hw2></Hw2>, document.querySelector('#root'));
export default Hw2;
